import Contract from "slotworks/utils/contracts/contract";
import AnimateSymbolBehaviour from "./animate-symbol-behaviour";

export default class RemoveAnimateSymbolBehaviour extends AnimateSymbolBehaviour {

    public behaviourName: string = "remove";

    public remove(): Contract<void> {
        return new Contract<void>((resolve) => {
            return super.animate(["_remove", "_remove_animate"], [], true).then(() => {
                this.symbol.setVisible(false);
                resolve(null);
            });
        });
    }
}
